import React from 'react'
import ProjectInfo from '../ProjectInfo'

import coffee from "../../../../Assets/images/projects/coffeedetailed.png"


export default function Coffee() {
    return (
        <ProjectInfo pic={coffee}
            title="CoffeeHaus Daily Manager"
            maincolor="#2a37b4"
            accentcolor="#1586cc"
            link="https://coffee-haus.netlify.app/"
            githublink="https://github.com/Jrwolf99/Coffee-Haus"
        >

            <p > This web application solves your everyday need for a life manager.
                It provides the user with a structured journal for productivity and lessons learned.
                This appliation also has habit section for checking off a list of habits every day.</p>
            <br />
            <p>Created with React, this app stores all
                information in Google's Firebase
                and is completely secured through
                Google's authentication service.</p>
            <br />


        </ProjectInfo >




    )
}
